import { apiFetch } from './client'
import type { StrategyAllocationResponse, StrategyState } from '../types/strategy'

export function fetchStrategyState(portfolioId: string): Promise<StrategyState> {
  return apiFetch<StrategyState>(`/api/strategy/${encodeURIComponent(portfolioId)}`)
}

export function fetchStrategyAllocation(
  portfolioId: string,
  mode: string
): Promise<StrategyAllocationResponse> {
  return apiFetch<StrategyAllocationResponse>(
    `/api/strategy/${encodeURIComponent(portfolioId)}/allocate`,
    {
      method: 'POST',
      body: JSON.stringify({ mode }),
    }
  )
}
